import React, { useCallback, useEffect, useState } from "react";
import { Link, redirect, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
// import MainPagetitle from "../../../jsx/layouts/MainPagetitle";
import BookingDetailItem from "../booking/BookingDetailItem";
// import { toast } from "react-toastify";
import BookingDetailItemIcon from "../booking/BookingDetailItemIcon";
import { resetHotelView, viewHotel } from "src/store/reducers/hotels";
import HotelFormCanvas from "./HotelFormCanvas";

const ViewHotel = () => {
  const dispatch = useAppDispatch();

  const { id: hotelId } = useParams();

  const hotelViewStatus = useAppSelector((state) => state.hotels.view.status);
  const hotelData = useAppSelector((state) => state.hotels.view.data);
  const [editId, setEditId] = useState("");
  // const [checkedList, setCheckedList] = useState<number[]>([]);
  // const [currentPage, setCurrentPage] = useState(0);
  // const sort = 5;

  useEffect(() => {
    if (!hotelId) {
      redirect("/hotels");
    }
  }, [hotelId]);

  const retry = useCallback(() => {
    dispatch(viewHotel(hotelId));
  }, [hotelId, dispatch]);

  useEffect(() => {
    if (hotelViewStatus === "idle") {
      retry();
    }
  }, [hotelViewStatus, retry]);

  useEffect(() => {
    if (hotelData?.id !== hotelId) {
      dispatch(resetHotelView());
    }
  }, [hotelData?.id, hotelId, dispatch]);

  return (
    <>
      {/* <MainPagetitle
        mainTitle="View Booking"
        pageTitle="View Booking"
        parentTitle="Home"
      /> */}
      <div className="container-fluid mh-auto">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                {hotelViewStatus === "success" && hotelData ? (
                  <div className="row">
                    <div className="col-xl-3 col-lg-3  col-md-3 col-sm-3">
                      <div className="about-me">
                        <ul>
                          <BookingDetailItemIcon
                            title={"Hotel name"}
                            icon={"hotel"}
                            value={hotelData.name}
                          />
                          <BookingDetailItemIcon
                            icon={"phone"}
                            title={"Contact number"}
                            value={hotelData.contact_number}
                          />
                          <BookingDetailItemIcon
                            icon={"plane-arrival"}
                            title={"City"}
                            value={hotelData.city}
                          />
                          <BookingDetailItemIcon
                            icon={"user-md"}
                            title={"Contact person"}
                            value={hotelData.contact_person_name}
                          />
                          {/* <li>
                            <i className="fa-solid fa-book"></i>
                            <div>
                              <h6>Techno India NJR Institute</h6>
                            </div>
                          </li>
                          <li>
                            <i className="fa-solid fa-location-dot"></i>
                            <div>
                              <h6>Lived In Usa</h6>
                            </div>
                          </li> */}
                        </ul>
                      </div>
                      <div className="d-flex mt-4 justify-content-end">
                        <Link
                          to={"#"}
                          onClick={() => setEditId(hotelData.id)}
                          className="modal-btn btn btn-primary btn-sm  ms-2"
                        >
                          <i className="fa-solid fa-pen-to-square me-1"></i>
                          Edit
                        </Link>
                        {/* <button
                          type="button"
                          className="modal-btn btn btn-primary btn-sm  ms-2 "
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal3"
                        >
                          <i className="fa-solid fa-pen-to-square me-1"></i>
                          <span>Edit </span>
                        </button> */}
                      </div>
                    </div>
                    <div className="col-xl-9 col-lg-9  col-md-9 col-sm-9">
                      <div className="product-detail-content">
                        <div className=" pr">
                          {/* <h4
                            className="heading mb-0"
                            style={{ wordWrap: "break-word" }}
                          >
                            View booking details
                          </h4>
                          <Link
                            to={"#"}
                            onClick={() => setEditId(hotelData.id)}
                            className="product-review text-primary align-items-sm-end"
                          >
                            Edit
                          </Link> */}

                          <div className="row">
                            <div className="col-xl-6 col-lg-6  col-md-6 col-sm-6 c-details">
                              <ul>
                                <BookingDetailItem
                                  title={"Address"}
                                  value={hotelData.address}
                                />
                                <BookingDetailItem
                                  title={"Email"}
                                  value={hotelData.email_id}
                                />
                                <BookingDetailItem
                                  title={"Category"}
                                  value={hotelData.category}
                                />
                                {/* <BookingDetailItem
                            title={"User"}
                            value={hotelData.user}
                          /> */}
                                <BookingDetailItem
                                  title={"Created"}
                                  value={new Date(
                                    hotelData.created_date
                                  ).toLocaleString('en-IN')}
                                />
                                <BookingDetailItem
                                  title={"Updated"}
                                  value={new Date(
                                    hotelData.updated_date
                                  ).toLocaleString('en-IN')}
                                />
                              </ul>
                            </div>

                            <div className="col-xl-6 col-lg-6  col-md-6 col-sm-6 c-details">
                              <ul>
                                <BookingDetailItem
                                  title={"Reservation contact no"}
                                  value={hotelData.reservation_contact_number}
                                />
                                <BookingDetailItem
                                  title={"Account details"}
                                  value={hotelData.account_details}
                                />
                                <BookingDetailItem
                                  title={"Location"}
                                  value={hotelData.location}
                                />
                                <BookingDetailItem
                                  title={"Notes"}
                                  value={hotelData.notes}
                                />
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : hotelViewStatus === "pending" ||
                  hotelViewStatus === "idle" ? (
                  <div className="d-flex align-items-center">
                    <strong>Loading...</strong>
                    <div
                      className="spinner-border ms-auto"
                      role="status"
                      aria-hidden="true"
                    ></div>
                  </div>
                ) : hotelViewStatus === "error" ? (
                  <div className="d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-warning"
                      onClick={retry}
                    >
                      Retry
                    </button>{" "}
                    &nbsp;
                    <strong onClick={retry}>Please try again </strong>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {/* review */}
        </div>
      </div>
      {hotelData ? (
        <>
          <HotelFormCanvas
            show={editId !== ""}
            hide={() => setEditId("")}
            editId={editId}
            Title={editId === "Add" ? "Add Hotel" : "Edit Hotel"}
            hotelData={hotelData}
          />
        </>
      ) : null}
    </>
  );
};

export default ViewHotel;
